import { ErrorBase } from '@/errors/ErrorBase';

export class NotAuthorizedError extends ErrorBase {
    static get defaultMessage(): string {
        return 'クラウドIDまたはログインIDまたはパスワードがちがいます。';
    }

    static get errorName(): string {
        return 'NotAuthorizedError';
    }
}
